export default "__VITE_ASSET__Xl1AYeBY__"